import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React from 'react';
import { paginate, mobilePaginate } from './paginationHelper';
import { PaginationItem } from './PaginationItem';
import { paginationStyles as classes } from './styles';
/**
 * A component that allows for navigating through paged results.
 */
export const Pagination = ({ currentPage, totalRecordCount, maxRecordsPerPage, siblings = { desktop: 1, mobile: 2 }, boundaries = 1, color = 'blue', renderItem = (props) => _jsx(PaginationItem, { ...props }), pageLabel = (page) => `Go to page ${page}`, prevLabel = 'Go to previous page', nextLabel = 'Go to next page', onPageChange, ref, ...props }) => {
    const paginationSiblings = typeof siblings === 'number' ? { desktop: siblings, mobile: siblings } : siblings;
    const totalPages = Math.ceil(totalRecordCount / maxRecordsPerPage);
    const paginationItems = paginate(currentPage, totalPages, paginationSiblings.desktop, boundaries);
    const mobilePaginationItems = mobilePaginate(currentPage, totalPages, paginationSiblings.mobile);
    return (_jsxs("nav", { ref: ref, "aria-label": 'Pagination', css: classes.pagination, ...props, children: [renderItem({
                type: 'previous',
                color,
                label: prevLabel,
                page: currentPage - 1,
                disabled: currentPage <= 1,
                onPageChange,
            }), _jsx("div", { css: [classes.pagination, classes.desktopPagination], children: paginationItems.map((page, index) => {
                    return (_jsx(React.Fragment, { children: page ? (renderItem({
                            type: 'page',
                            color,
                            label: pageLabel(page),
                            page,
                            isSelected: page === currentPage,
                            onPageChange,
                        })) : (_jsx(PaginationItem, { type: 'dots', color: color })) }, index));
                }) }), _jsx("div", { css: [classes.pagination, classes.mobilePagination], children: mobilePaginationItems.map((page, index) => {
                    return (_jsx(React.Fragment, { children: renderItem({
                            type: 'page',
                            color,
                            label: pageLabel(page),
                            page,
                            isSelected: page === currentPage,
                            onPageChange,
                        }) }, index));
                }) }), renderItem({
                type: 'next',
                color,
                label: nextLabel,
                page: currentPage + 1,
                disabled: currentPage >= totalPages,
                onPageChange,
            })] }));
};
